"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  addToBag: 'Add to bag',
  cataloguePrice: 'Catalogue price',
  deliveryFrequencyLabel: 'Delivery frequency',
  deliveryFrequencyOptions: 'Every 3rd week (Recommended);Every 4th week;Every 5th week;Every 6th week;Every 7th week;Every 8th week;Every 9th week',
  every2Week: 'Every 2nd week',
  every3Week: 'Every 3rd week',
  every4Week: 'Every 4th week',
  every5Week: 'Every 5th week',
  every6Week: 'Every 6th week',
  every7Week: 'Every 7th week',
  every8Week: 'Every 8th week',
  every9Week: 'Every 9th week',
  gotIt: 'Got it',
  learnMore: 'Learn more',
  mrp: 'MRP',
  mrpStatement: 'Inclusive of all taxes',
  priceCashback: '{price} cashback',
  purchaseOption: 'One-time purchase',
  quantity: 'Quantity',
  recommended: 'Recommended',
  regularPrice: 'Regular price',
  subscribeBenefits: '30% cashback on every order;Free shipping;Cancel, change, or delay anytime;30-day money-back guarantee;Always lowest price',
  subscribeBenefitsBrandPartner: '10% cashback on every order;10 extra Bonus Points on every product;Free shipping;Cancel, change, or delay anytime;30-day money-back guarantee;Always lowest price',
  subscribeCashbackDescription: 'On every order',
  subscribeInfoDescriptions: 'By subscribing to our products, you’ll enjoy an additional 15% cashback, bringing your total cashback to 30% on every order.;We offer free shipping on all subscription orders. Include your next subscription shipment with your regular order to get free shipping.;We’ll remind you about every subscription order before it ships. You can choose to delay a delivery, change it, or cancel altogether - directly in your account.;Try your subscription worry-free! If you’re not fully satisfied, you can return your order within 30 days for a full refund.;You’ll always receive your subscription products at the lowest available price - never miss out on a deal.',
  subscribeInfoDescriptionsBrandPartner: 'With subscription products, you’ll enjoy an extra 10% cashback on top of your 20% Brand Partner discount for every order.;As part of your subscription, you’ll receive an additional 10 Bonus Points (BPs) for each product you order.;We offer free shipping on all subscription orders. Include your next subscription shipment with your regular order to get free shipping.;We’ll remind you about every subscription order before it ships. You can choose to delay a delivery, change it, or cancel altogether - directly in your account.;Try your subscription worry-free! If you’re not fully satisfied, you can return your order within 30 days for a full refund.;You’ll always receive your subscription products at the lowest available price - never miss out on a deal.',
  subscribeInfoMainTitle: 'Subscription',
  subscribeInfoSubtitles: '30% cashback on every order;Free shipping on all subscriptions;Cancel, change, or delay anytime;30-day money-back guarantee;Always lowest price',
  subscribeInfoSubtitlesBrandPartner: '10% cashback on every order;10 extra Bonus Points on every product;Free shipping on all subscriptions;Cancel, change, or delay anytime;30-day money-back guarantee;Always lowest price',
  subscribeOption: 'Subscribe & Save',
  yourPrice: 'Your price'
};
const translationsNamespace = exports.translationsNamespace = 'presentation-product-detail';
